import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "center/wallet";
const options = {role: ROLE.CENTER};


export const list = async (values) => {
  return await axiosInstance(options).post(`${path}/list-transactions`, values);
}

export const add = async (values, role) => {
  return await axiosInstance(role ? { role } : options).post(`${path}/credit-amount`, values);
}